<template>
  <AulaTemplate
    :titulo="$store.state.topicos[3].titulo"
    titleSize="5"
  >
    <TextBlock>
      <v-row style="word-break: break-word">
        <v-col cols="12">
          <Paragraph>
            BRASIL. Lei n. 14.440, de 2 de setembro de 2022. Altera a Lei nº
            9.503, de 23 de setembro de 1997 - Código de Trânsito Brasileiro,
            para dispor sobre limites de velocidade para ultrapassagens em vias
            rurais e dispositivos auxiliares à segurança de motociclistas.
            Diário Oficial da União: seção 1, Brasília, DF, p. 1, 5 set. 2022.
            Disponível em:
            <a
              href="https://www.planalto.gov.br/ccivil_03/_ato2022-2026/2022/lei/L14440.htm"
              target="_blank"
              >https://www.planalto.gov.br/ccivil_03/_ato2022-2026/2022/lei/L14440.htm</a
            >. Acesso em: 13 set. 2024.
          </Paragraph>

          <Paragraph>
            BRASIL. Lei nº 9.503, de 23 de setembro de 1997. Institui o Código
            de Trânsito Brasileiro. Disponível em:
            <a
              href="https://www.planalto.gov.br/ccivil_03/LEIS/L9503Compilado.htm"
              target="_blank"
              >https://www.planalto.gov.br/ccivil_03/LEIS/L9503Compilado.htm</a
            >. Acesso em: 20 ago. 2024.
          </Paragraph>

          <Paragraph>
            BRASIL. Lei nº 14.071, de 13 de outubro de 2020. Altera a Lei nº
            9.503, de 23 de setembro de 1997. Disponível em:
            <a
              href="https://www.planalto.gov.br/ccivil_03/leis/L14071.htm"
              target="_blank"
              >https://www.planalto.gov.br/ccivil_03/leis/L14071.htm</a
            >. Acesso em: 20 ago. 2024.
          </Paragraph>

          <Paragraph>
            CONSELHO NACIONAL DE TRÂNSITO (BRASIL) (CONTRAN). Manual Brasileiro
            de Sinalização de Trânsito: Sinalização vertical de regulamentação.
            2. ed. Brasília: Contran, 2007. 220 p. : il.
          </Paragraph>

          <Paragraph>
            BRASIL. Ministério das Cidades. Cartilha de Direção Defensiva.
            Brasília: Governo Federal, 2008.
          </Paragraph>

          <Paragraph>
            DENATRAN – Departamento Nacional de Trânsito. Manual Brasileiro de
            Sinalização de Trânsito – Volume III: Sinalização Horizontal. 1. ed.
            Brasília: Ministério das Cidades, 2014. Disponível em:
            <a
              href="https://www.gov.br/infraestrutura/pt-br/assuntos/transito/denatran"
              target="_blank"
              >https://www.gov.br/infraestrutura/pt-br/assuntos/transito/denatran</a
            >. Acesso em: 13 set. 2024.
          </Paragraph>
        </v-col>
      </v-row>
    </TextBlock>

  </AulaTemplate>
</template>

<script>
import AulaTemplate from "@/components/AulaTemplate.vue";
import TextBlock from "@/components/TextBlock.vue";
import Paragraph from "@/components/Paragraph.vue";

export default {
  components: {
    AulaTemplate,
    TextBlock,
    Paragraph,
  },
};
</script>

<style scoped>
a:link,
a:visited {
  color: #fff !important;
  font-weight: bold;
}
</style>
